import React, { useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Delete, FileCopy, Edit } from '@mui/icons-material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  wrapper: {
    position: 'relative',
    width: '128px',
    height: '128px',
    border: '2px solid transparent',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    overflow: 'hidden',
    backgroundColor: '#f5f5f5',
    '&:hover': {
      borderColor: '#3C55E8',
      '& $actionWrapper': {
        opacity: 1,
      },
    },
  },
  selected: {
    borderColor: '#3C55E8',
    borderWidth: '3px',
  },
  actionWrapper: {
    position: 'absolute',
    top: '4px',
    right: '4px',
    display: 'flex',
    gap: '4px',
    opacity: 0,
    transition: 'opacity 0.2s ease',
    zIndex: 2,
  },
  actionBtn: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
    },
  },
  actionIcon: {
    fontSize: '14px',
    color: 'white',
  },
  frame: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '6px',
  },
  hide: {
    display: 'none',
  },
  framePlaceholder: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#e0e0e0',
    borderRadius: '6px',
    color: '#888',
  },
  fileName: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    color: 'white',
    padding: '4px 8px',
    fontSize: '10px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderBottomLeftRadius: '6px',
    borderBottomRightRadius: '6px',
  },
}));

export const DisplayFile = ({
  selected,
  file,
  setSelected,
  deleteFile,
  editFile,
}) => {
  const classes = useStyles();
  const [loadedImage, setLoadedImage] = useState(false);

  return (
    <Box className={clsx(classes.wrapper, { [classes.selected]: selected })}>
      <Box className={classes.actionWrapper}>
        <Box
          onClick={editFile}
          data-testid="edit-image"
          className={classes.actionBtn}
        >
          <Edit className={classes.actionIcon} />
        </Box>
        <Box
          onClick={deleteFile}
          data-testid="delete-image"
          className={classes.actionBtn}
        >
          <Delete className={classes.actionIcon} />
        </Box>
      </Box>
      <Box onClick={setSelected} data-testid="image-wrapper">
        {file.mime && file.mime.includes('image') ? (
          <>
            {!loadedImage && (
              <Box style={{ height: '128px', width: '128px', display: 'flex' }}>
                <CircularProgress
                  style={{ margin: 'auto' }}
                  data-testid="progress"
                />
              </Box>
            )}
            <img
              src={file.url}
              data-testid="image"
              alt=""
              onLoad={() => setLoadedImage(true)}
              className={clsx(classes.frame, { [classes.hide]: !loadedImage })}
            />
          </>
        ) : (
          <Box className={classes.framePlaceholder}>
            <FileCopy />
          </Box>
        )}
        <Typography className={classes.fileName}>
          {file.name || file.id}
        </Typography>
      </Box>
    </Box>
  );
};

DisplayFile.propTypes = {
  selected: PropTypes.bool,
  file: PropTypes.shape({
    url: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    mime: PropTypes.string,
  }),
  setSelected: PropTypes.func,
  deleteFile: PropTypes.func,
  editFile: PropTypes.func,
};

export default DisplayFile;
